import React, {useEffect} from "react";
import {motion} from "framer-motion";

// Render a safe string even if `message` is accidentally an object.
const toText = (value) => {
  if (typeof value === "string") return value;
  if (value === undefined || value === null) return "";
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (typeof value === "object") {
    const candidate = value.message ?? value.error;
    if (candidate !== undefined && candidate !== null) return toText(candidate);
    return JSON.stringify(value);
  }
  return String(value);
};

// Named Tailwind tokens instead of the legacy .toast-message CSS rules.
const TOAST_BASE =
  "pointer-events-auto fixed left-1/2 top-24 z-[11000] -translate-x-1/2 rounded-md px-5 py-3 text-sm font-bold text-white shadow-lg";
const TOAST_TONE = {
  success: "bg-success text-success-foreground",
  error: "bg-destructive text-destructive-foreground",
};

const Toast = ({message, onClose, isSuccess = true}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(); // Hide after 5 seconds
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[11000] flex justify-center">
      <motion.div
        initial={{y: -50, opacity: 0}}
        animate={{y: 0, opacity: 1}}
        exit={{y: -50, opacity: 0}}
        role="status"
        className={`${TOAST_BASE} ${isSuccess ? TOAST_TONE.success : TOAST_TONE.error}`}
      >
        {toText(message)}
      </motion.div>
    </div>
  );
};

export default Toast;
